import React from 'react';
import { Fetch } from '@ekuaibao/fetch';
export var ApportionContext = React.createContext({
    form: undefined
});
var SpecialAllowCancelDependenceUtils = (function () {
    function SpecialAllowCancelDependenceUtils() {
    }
    SpecialAllowCancelDependenceUtils.isRefSpecial = function () {
        var whiteList = [
            'ID01iAVxDoSkkD',
            'BqZ3FWak0J00qg',
            'LOV3ErNSDb00Vw',
            'ID01jR6MK1IG7I',
            'ptMaTq8LIQbg00',
            'Rlx3kgsCrz00uM',
            '59s8ib_XFc3w00',
            'wkz3LxRHqy02yv',
            'ID01kUkij7Uu7l',
            'ID01q89hU2D5fh',
            'ID01ocBH12O7kb',
            'ID01nZk21XQGth',
            'ID01uHQR86Cnsb',
            'ID01rWUzm7239R',
        ];
        if (Fetch === null || Fetch === void 0 ? void 0 : Fetch.ekbCorpId) {
            return whiteList.includes(Fetch === null || Fetch === void 0 ? void 0 : Fetch.ekbCorpId);
        }
        else if (Fetch === null || Fetch === void 0 ? void 0 : Fetch.corpId) {
            return whiteList.includes(Fetch === null || Fetch === void 0 ? void 0 : Fetch.corpId);
        }
        return false;
    };
    return SpecialAllowCancelDependenceUtils;
}());
export { SpecialAllowCancelDependenceUtils };
